var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gauge-bar",attrs:{"title":_vm.tooltip()}},_vm._l((_vm.indexes),function(index){return _c('span',{key:index,staticClass:"gauge-box",class:{'gauge-box-fill': _vm.val >= index}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }